import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import AnnouncementPopup from './components/AnnouncementPopup';
import CustomCodeInjector from './components/CustomCodeInjector';
import Home from './pages/Home';
import About from './pages/About';
import AboutGroup from './pages/AboutGroup';
import PrincipalMessage from './pages/PrincipalMessage';
import CoreValues from './pages/CoreValues';
import StructuredPage from './pages/StructuredPage';
import WhyUs from './pages/WhyUs';
import Fees from './pages/Fees';
import GalleryPage from './pages/GalleryPage';
import GalleryDetail from './pages/GalleryDetail';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Contact from './pages/Contact';
import DynamicPage from './pages/DynamicPage';
import Recognition from './pages/Recognition';
import AdmissionGuidelines from './pages/AdmissionGuidelines';
import OurPhilosophy from './pages/OurPhilosophy';
import Accreditation from './pages/Accreditation';
import CbseBoard from './pages/CbseBoard';
import CurriculumInfrastructure from './pages/CurriculumInfrastructure';
import InfrastructurePage from './pages/InfrastructurePage';
import StudentEngagementPage from './pages/StudentEngagementPage';
import OtherFacilitiesPage from './pages/OtherFacilitiesPage';
import OurProgrammesPage from './pages/OurProgrammesPage';
import ExposureCodingPage from './pages/ExposureCodingPage';
import ExtraCurriculumActivitiesPage from './pages/ExtraCurriculumActivitiesPage';
import JuniorSchoolProgrammePage from './pages/JuniorSchoolProgrammePage';
import MiddleSchoolProgrammePage from './pages/MiddleSchoolProgrammePage';
import SeniorSchoolProgrammePage from './pages/SeniorSchoolProgrammePage';
import JobApplicationForm from './pages/JobApplicationForm';
import MandatoryPublicDisclosure from './pages/MandatoryPublicDisclosure';
import PublicNotice from './pages/PublicNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';
import OtherBranches from './pages/OtherBranches';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  useEffect(() => { 
    window.scrollTo(0, 0); 
    // Clean up internal query flags like ?spa=1 or ?_og=1 from address bar seamlessly
    if (search && (search.includes('spa=1') || search.includes('_og=1'))) {
      const cleanSearch = search
        .replace(/[?&](spa=1|_og=1)/g, '')
        .replace(/^&/, '?');
      const newUrl = pathname + (cleanSearch ? `?${cleanSearch}` : '') + window.location.hash;
      window.history.replaceState({}, '', newUrl);
    }
  }, [pathname, search]);
  return null;
};

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <AnnouncementPopup />
      <CustomCodeInjector />
      <main className="overflow-hidden">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/about-standrews-group" element={<AboutGroup />} />
          <Route path="/why-us" element={<WhyUs />} />
          <Route path="/principals-message" element={<PrincipalMessage />} />
          <Route path="/core-values" element={<CoreValues />} />
          <Route path="/academics" element={<StructuredPage slug="academics" />} />
          <Route path="/curriculum" element={<StructuredPage slug="curriculum" />} />
          <Route path="/our-programmes" element={<StructuredPage slug="our-programmes" />} />
          <Route path="/foundational-programme" element={<StructuredPage slug="foundational-programme" />} />
          <Route path="/preparatory-programme" element={<StructuredPage slug="preparatory-programme" />} />
          <Route path="/middle-programme" element={<StructuredPage slug="middle-programme" />} />
          <Route path="/beyond-the-classroom" element={<StructuredPage slug="beyond-the-classroom" />} />
          <Route path="/other-facilities" element={<StructuredPage slug="other-facilities" />} />
          <Route path="/extra-curricular-activities" element={<StructuredPage slug="extra-curricular-activities" />} />
          <Route path="/curriculum-and-infrastructure" element={<CurriculumInfrastructure />} />
          <Route path="/extra-curriculum-activities" element={<ExtraCurriculumActivitiesPage />} />
          <Route path="/other-facilities" element={<OtherFacilitiesPage />} />
          <Route path="/job-application-form" element={<JobApplicationForm />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/recognition" element={<Recognition />} />
          <Route path="/admission-guidelines" element={<AdmissionGuidelines />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/gallery/:slug" element={<GalleryDetail />} />
          <Route path="/article" element={<Blog />} />
          <Route path="/article/:slug" element={<BlogDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/our-programmes" element={<OurProgrammesPage />} />
          <Route path="/junior-school-programme" element={<JuniorSchoolProgrammePage />} />
          <Route path="/middle-school-programme" element={<MiddleSchoolProgrammePage />} />
          <Route path="/senior-school-programme" element={<SeniorSchoolProgrammePage />} />
          <Route path="/accreditation" element={<Accreditation />} />
          <Route path="/cbse-board" element={<CbseBoard />} />
          <Route path="/exposure-to-programming-and-coding-languages" element={<ExposureCodingPage />} />
          <Route path="/recognition" element={<Recognition />} />
          <Route path="/infrastructure" element={<InfrastructurePage />} />
          <Route path="/student-engagement" element={<StudentEngagementPage />} />
                    <Route path="/fees" element={<Fees />} />
          <Route path="/other-branches" element={<OtherBranches />} />
          <Route path="/mandatory-public-disclosure" element={<MandatoryPublicDisclosure />} />
          <Route path="/public-notice" element={<PublicNotice />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/:slug" element={<DynamicPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;


